<template>
  <div class="mw-panel">
    <div class="mw-toolbar">
      <mw-button @click="save" :disabled="disabledSave" icon="fa fa-save">保存</mw-button>
      <mw-button @click="getPath" icon="fa fa-map">获取路径</mw-button>
      <el-button type="info" @click="helpnotes" class="pull-right" style="margin-top: 8px;">
        <i class="fa fa-question"></i>帮助
      </el-button>
    </div>
    <div class="mw-toolbar__body">
      <el-form label-width="130px" class="mw-form" :model="form" ref="form">
        <el-col :span="24">
          <el-form-item prop="id" v-show="false">
            <el-input v-model="form.id"></el-input>
          </el-form-item>
          <el-form-item label="显示名称" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="链接类型" prop="linkType">
            <el-radio-group v-model="form.linkType" @change="linkTypeChange">
              <!-- <el-radio label="cate">分类</el-radio> -->
              <el-radio label="view">视图</el-radio>
              <!--  <el-radio v-model="form.linkType" label="form">表单</el-radio>
                <el-radio v-model="form.linkType" label="js">js脚本</el-radio>
                <el-radio v-model="form.linkType" label="link">链接目标</el-radio>-->
              <el-radio label="page">页面</el-radio>
              <el-radio label="inner">内置视图</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="链接目标" prop="target">
            <el-input v-model="form.target" readonly @change="chageTarget">
            </el-input>
            <el-button @click="selectTarget">选择</el-button>
          </el-form-item>
          <el-form-item prop="targetId" v-show="false">
            <el-input v-model="form.targetId"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="导航图标" prop="icon">
            <MwIconSelect v-model="form.icon" style="width:60%;" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="图标颜色" prop="bgColor">
            <MwColorSelect  v-model="form.bgColor" style="width:60%;" />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="显示风格" prop="style">
            <el-radio v-model="form.style" label="tree">树状菜单</el-radio>
            <el-radio v-model="form.style" label="full">没导航菜单</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="form.style=='full'">
          <el-form-item label="导航隐藏" prop="navHide">
            <el-radio v-model="form.navHide" label="0">隐藏</el-radio>
            <el-radio v-model="form.navHide" label="1">显示</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="权限过滤" prop="exp">
            <el-input v-model="form.exp"></el-input>
            <el-button @click="setFormExp">生成表达式</el-button>
            <el-button @click="clearFormExp">清空</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="是否显示" prop="disable">
            <el-radio v-model="form.disable" label="1">是</el-radio>
            <el-radio v-model="form.disable" label="0">否</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="额外参数" prop="ewcs">
            <el-input v-model="form.ewcs"></el-input>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
    <el-dialog ref="authority" width="800px" :before-close="closeAuthory" :visible.sync="dialogFormVisible">
      <div slot="title">
        <span style="margin-right: 12px;">生成权限表达式</span>
        <el-button type="info" @click="helpnotes('auth')">
          <i class="fa fa-question"></i>帮助
        </el-button>
      </div>
      <el-form :model="authorityForm">
        <el-table :data="authorityForm" height="250" border style="width: 100%">
          <el-table-column prop="zdmc" label="字段名称" type="index" width="280">
            <template slot-scope="scope">
              <el-input v-model="scope.row.zdmcstr" placeholder="字段名称" readonly style="width: 80%;"></el-input>
              <el-button @click.prevent="selectZdmc(scope.row, scope.$index)">选择</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="bjf" label="比较值" type="index" width="98">
            <template slot-scope="scope">
              <el-select v-model="scope.row.bjf">
                <el-option label="请选择" value=""></el-option>
                <el-option v-if="scope.row.zdmc=='$D'" label="等于(包含子部门)" value="~~"></el-option>
                <el-option v-if="scope.row.zdmc=='$D'" label="不等于(包含子部门)" value="!~~"></el-option>
                <el-option :label="scope.row.zdmc=='$roleNames'?'包含':'等于'" value="=="></el-option>
                <el-option :label="scope.row.zdmc=='$roleNames'?'不包含':'不等于'" value="!="></el-option>
                <!-- <el-option v-if="scope.row.zdmc!='$roleNames' && scope.row.zdmc!='$D'" label="包含" value="like"></el-option>
                <el-option v-if="scope.row.zdmc!='$roleNames' && scope.row.zdmc!='$D'" label="不包含" value="unlike"></el-option> -->
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="srz" label="输入值" type="index" width="280">
            <template slot-scope="scope">
              <el-input v-model="scope.row.srzstr" :readonly="scope.row.zdmc=='$D'?true:false" placeholder="输入值" :style="{width: scope.row.zdmc=='$D'?'80%':'100%'}"></el-input>
              <el-button v-if="scope.row.zdmc=='$D'" @click.prevent="selectDept(scope.row, scope.$index)">选择</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="gxf" label="关系符" type="index" width="98">
            <template slot-scope="scope">
              <el-select v-model="scope.row.gxf">
                <el-option label="并且" value="and"></el-option>
                <el-option label="或者" value="or"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div>
        <p style="margin-top: 10px; font-size: 16px; font-weight: 600;">预览:</p>
        <div>
          {{previewAuthory}}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addAuthory">添加一行</el-button>
        <el-button @click="closeAuthory">取 消</el-button>
        <el-button type="primary" @click="setAuthory">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog ref="selzdmc" title="选择字段名称" width="300px" :show-close="false" :before-close="clearCurzdmc" :visible.sync="dialogSelectVisible">
      <div style="width: 100%; height: 8px;"></div>
      <p><el-radio v-model="curzdmc" label="$loginId">登陆ID</el-radio></p>
      <p><el-radio v-model="curzdmc" label="$userName">用户名称</el-radio></p>
      <p><el-radio v-model="curzdmc" label="$roleNames">身份权限</el-radio></p>
      <p><el-radio v-model="curzdmc" label="$D">单位或部门(ID)</el-radio></p>
      <!-- <p><el-radio v-model="curzdmc" label="$primaryOrgName">单位名称</el-radio></p> -->
      <!-- <p><el-radio v-model="curzdmc" label="$isAdmin">是否管理员</el-radio></p>
      <p><el-radio v-model="curzdmc" label="$editmode">编辑常量</el-radio></p> -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogSelectVisible = false">取 消</el-button>
        <el-button type="primary" @click.prevent="setCurzdmc">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["node", "appId"],
  data() {
    return {
      form: {
        category: "link",
        name: "",
        exp: "",
        disable: "1",
        linkType: "view",
        style: "tree",
        unit: "1",
        dept: "0",
        targetId: "",
        parentId: "",
        nav: "1",
        target: "",
        way: "1",
        icon: "",
        navHide:'0',
        ewcs: "",
        bgColor: "",
        authorityForm: []
      },
      authorityForm: [{
        zdmc:'',
        zdmcstr: '',
        bjf: '',
        srz: '',
        srzstr: '',
        gxf: 'and'
      }],
      curzdmc: '',
      disabledSave: false,
      dialogFormVisible: false,
      dialogSelectVisible: false,
      scopeIndex: null,
      viewTarget: '',
      viewTargetId: '',
      pageTarget: '',
      pageTargetId: '',
      cateTarget: '',
      cateTargetId: '',
      innerTarget: '',
      innerTargetId: '',
      zdmcKv: {
        $loginId:'登陆ID',
        $userName:'用户名称',
        $roleNames:'身份权限',
        $D:'单位或部门(ID)'
      }
    };
  },
  mounted() {
    let me = this;

    me.loadData();
    me.chageTarget();

    this.$nextTick(a=>{
      $('.x-icon-chooser table td button').css('margin-right', '-53px');
      $('.x-icon-chooser table td button').addClass('el-button');
    });
    /*if (!me.linkId.startsWith('add')) {
        me.mwApi.app.getApplicationLink(me.linkId, me.appId).then((data) => {
          if(data.result.unit==undefined){
            data.result.unit="0";
          }
          if(data.result.dept==undefined){
            data.result.dept="0";
          }
          Object.assign(me.form, data.result);
        });
      } else {
        if (me.linkId.length > 3) {
          me.form.parentId = me.linkId.split("_")[1];
        }
      }*/

  },
  watch: {
    node() {
      this.loadData();
    }
  },
  computed: {
    fwPath() {
      let path;
      let item = this.form;
      item.id = this.linkId;
      if (item.linkType == "inner") {
        //内置视图
        path =
          "/dashboard/" +
          (this.appId || "【当前应用id】") +
          "/" +
          item.style +
          "/" +
          (item.id || "【当前树节点id】") +
          "/" +
          item.linkType +
          "/" +
          (item.id || "【当前树节点id】") +
          "/" +
          item.targetId;
      } else if (item.linkType == "view") {
        path =
          "/dashboard/" +
          (this.appId || "【当前应用id】") +
          "/" +
          item.style +
          "/" +
          (item.id || "【当前树节点id】") +
          "/" +
          item.linkType +
          "/" +
          (item.id || "【当前树节点id】");
      } else if (item.linkType == "page") {
        path =
          "/dashboard/" +
          (this.appId || "【当前应用id】") +
          "/" +
          item.style +
          "/" +
          (item.id || "【当前树节点id】") +
          "/" +
          item.linkType +
          "/" +
          item.targetId;
      } else {
        path =
          "/dashboard/" +
          (this.appId || "【当前应用id】") +
          "/" +
          item.style +
          "/" +
          (item.id || "【当前树节点id】") +
          "/" +
          item.linkType +
          "/index";
      }
      return path;
      // alert(path)
    },
    previewAuthory() {
      let result = '';
      let orexp='';
      let andexp='';
      this.authorityForm.forEach((item)=>{
        if (item.zdmc!=='$D') item.srz = item.srzstr;
        if (item.zdmc && item.bjf && item.srz && item.gxf) { //&& item.srz
          if (item.zdmc == '$roleNames') {
            let roles = '';
            const roleArr = item.srz.split(',');
            roleArr.forEach((role, ri)=>{
              role=role.replace(/\'|\"|‘|“|’|”/g, '');
              if (role) roles += (ri!==0 ? ',' : '') + '\'' + role + '\'';
            });
            if (roles) result = result + (item.bjf == '!=' ? '!' : '') + `$contains($roleNames, ${roles})` + (item.gxf == 'and' ? '&&' : '||');
          } else if (item.zdmc == '$D') {
              if (item.bjf == '~~' || item.bjf == '!~~') {
                result = result + (item.bjf == '!~~' ? '!' : '') + `$contains($deptIdChain, '${item.srz}')` + (item.gxf == 'and' ? '&&' : '||');
              } else {
                const srz = item.srz.replace(/\'|\"|‘|“|’|”/g, '');
                result = result + (item.bjf == '!=' ? '!' : '') + `${item.zdmc}('${srz}')` + (item.gxf == 'and' ? '&&' : '||');
              }
            } else {
            const srz = item.srz.replace(/\'|\"|‘|“|’|”/g, '');
            result += item.zdmc + item.bjf + "'" + srz + "'" + (item.gxf == 'and' ? '&&' : '||');
          }
        }
      });
      const bjf = result.substring(result.length-2, result.length);
      if (bjf == '&&' || bjf == '||') {
        result = result.substring(0,result.length-2);
      }
      return result;
    }
  },
  methods: {
    loadData() {
      this.clearTarget();
      let defaultValue = {
        category: "link",
        name: "",
        exp: "",
        disable: "1",
        linkType: "view",
        style: "tree",
        unit: "1",
        dept: "0",
        targetId: "",
        parentId: "",
        nav: "1",
        target: "",
        ewcs:'',
        way: "1",
        navHide:"0"
      };
      if (this.node && this.node.text !== "新链接") {
        if (!this.node.children) {
          delete this.form.children;
        }
        Object.assign(this.form, defaultValue);
        Object.assign(this.form, this.node);
      } else {
        let newForm = {};
        Object.assign(newForm, defaultValue);
        this.form = Object.assign(newForm, this.node);
      }
      this.chageTarget();
    },
    linkTypeChange(v) {
      let me = this;
      if (me.form.linkType == 'view') {
        this.form.target = this.viewTarget;
        this.form.targetId = this.viewTargetId
      } else if (me.form.linkType == 'page') {
        this.form.target = this.pageTarget;
        this.form.targetId = this.pageTargetId;
      } else if (me.form.linkType == 'cate') {
        this.form.target = this.cateTarget;
        this.form.targetId = this.cateTargetId;
      } else if (me.form.linkType == 'inner') {
        this.form.target = this.innerTarget;
        this.form.targetId = this.innerTargetId;
      }
    },
    selectTarget() {
      let me = this;
      if (me.form.linkType == "view") {
        //视图
        var checkNodes;
        if (me.form.targetId) {
          checkNodes = me.form.targetId.split(",");
        }

        PF.show(
          "treeTable",
          {
            url: this.mwUrl("/api/app/listApplicationTree"),
            size: "small_large",
            treeDefaultParams: { category: "view" },
            selectFirst: false,
            clearBtn: false,
            title: "选择视图",
            changed: function(data) {
              let me = this;
              me.defaultParams = { sysId: me.appId, code: data.code, category: "view" ,applicationId:data.id};
            },
            api: "app.getAppModuleItems",
            singleSelect: false
          },
          function(res) {
            if (res) {
              var targets = [];
              var targetIds = [];
              res.forEach(item => {
                targets.push(item.name);
                targetIds.push(item.id);
              });
              me.form.targetId = targetIds.join();
              me.form.target = targets.join();
              me.chageTarget();
            }
          }
        );
      }

      if (me.form.linkType == "page") {
        PF.show(
          "treeTable",
          {
            url: this.mwUrl("/api/app/listApplicationTree"),
            size: "small_large",
            treeDefaultParams: { category: "page" },
            selectFirst: false,
            clearBtn: false,
            title: "选择页面",
            changed: function(data) {
              let me = this;
              me.defaultParams = { sysId: me.appId, code: data.code, category: "page",applicationId:data.id};
            },
            api: "app.getAppModuleItems",
            singleSelect: true
          },
          function(res) {
            if (res && res.length > 0) {
              me.form.targetId = res[0].id;
              me.form.target = res[0].name;
            } else {
              me.form.targetId = "";
              me.form.target = "";
            }
            me.chageTarget();
          }
        );
      }

      if (me.form.linkType == "inner") {
        //内置视图
        PF.show(
          "tree",
          {
            treeData: [
              {
                id: $uuid(),
                text: "组织人员",
                hasChild: 6,
                children: [
                  {
                    id: "systemSet_org_user",
                    text: "组织成员",
                    type: "file"
                  },
                  {
                    id: "systemSet_org_group",
                    text: "角色管理",
                    type: "file"
                  },
                  {
                    id: "systemSet_org_roleList",
                    text: "角色管理(列表)",
                    type: "file"
                  },
                  {
                    id: "systemSet_org_role",
                    text: "权限定义",
                    type: "file"
                  },
                  {
                    id: "systemSet_org_InvalidUser",
                    text: "无效用户",
                    type: "file"
                  },{
                    id: "systemSet_org_full_auth",
                    text: "全权代办",
                    type: "file"
                  },
                  {
                    id: "systemSet_org_groups",
                    text: "群组管理",
                    type: "file"
                  },
                  {
                    id: "systemSet_org_outerOrg",
                    text: "外部单位",
                    type: "file"
                  },
                  {
                    id: "systemSet_recycleBin",
                    text: "回收站",
                    type: "file"
                  }
                ]
              },
              {
                id: $uuid(),
                text: "配置管理",
                hasChild: 8,
                children: [
                  {
                    id: "systemSet_org_dataDic",
                    text: "数据字典",
                    type: "file"
                  },
                  {
                    id: "systemSet_worktime",
                    text: "工作时间",
                    type: "file"
                  },
                  {
                    id: "systemSet_script",
                    text: "动作脚本",
                    type: "file"
                  },
                  {
                    id: "systemSet_flow",
                    text: "流程配置",
                    type: "file"
                  },
                  {
                    id: "systemSet_multilingual",
                    text: "语言管理",
                    type: "file"
                  },
                  {
                    id:'systemSet_navigator',
                    text:"导航设置",
                    type:"file"
                  }
                ]
              },
              {
                id: $uuid(),
                text: "维护管理",
                hasChild: 2,
                children: [
                  {
                    id: "clear_data_or_exp_impl",
                    text: "数据清理及导出",
                    type: "file"
                  },
                  {
                    id: "systemSet_flowInterfering",
                    text: "流程干预",
                    type: "file"
                  }
                ]
              },
              {
                id: $uuid(),
                text: "日志管理",
                hasChild: 4,
                children: [
                  {
                    id:'systemSet_log_operationLog',
                    text:'管理日志',
                    type:"file"
                  },
                  {
                    id:'systemSet_log_personalLog',
                    text:'操作日志',
                    type:"file"
                  },
                  {
                    id:'systemSet_log_flowLog',
                    text:'流程日志',
                    type:"file"
                  },
                  {
                    id:'systemSet_log_loginLog',
                    text:'登录日志',
                    type:"file"
                  }
                ]
              }
            ],
            selectFirst: false,
            title: "选择内置视图",
            size: "mini_large",
            multiple: false,
            search: true,
            async: false,
            singleLeaf: true
          },
          function(res) {
            if (res) {
              me.form.targetId = res.id;
              me.form.target = res.text;
              me.chageTarget();
            }
          }
        );
      }
    },
    selectIcon() {
      let me = this;

    },
    save() {
      let me = this;
      me.disabledSave = true;
      if (me.form.name == "") {
        me.mwMsg("warning", "请输入名称");
        return;
      }
      let isNew = false;
      let data = {};
      Object.assign(data, me.node);

      Object.assign(data, me.form);
      data.text = data.name;

      if (data.id && data.parentId) delete me.form.id;
      if (!data.id) {
        data.id = $uuid();
        isNew = true;
      }

      me.mwApi.app.saveNavigatorTree(me.appId, data).then(res => {
        if (res.result) {
          me.$emit("afterSave", res.result, isNew);
          me.mwMsg("保存成功");
        } else {
          me.mwMsg("保存失败:" + res.errMsg);
        }
        me.disabledSave = false;
      });
    },
    getPath() {
      let path;
      let item = this.form;
      item.id = this.linkId;
      if (item.linkType == "inner") {
        //内置视图
        path = "/dashboard/" +(this.appId || "【当前应用id】") +"/" +
          item.style +"/" +(item.id || "【当前树节点id】") +  "/" +
          item.linkType +  "/" +(item.id || "【当前树节点id】") +"/" + item.targetId;
      } else if (item.linkType == "view") {
        path =
          "/dashboard/" +
          (this.appId || "【当前应用id】") +
          "/" +
          item.style +
          "/" +
          (item.id || "【当前树节点id】") +
          "/" +
          item.linkType +
          "/" +
          (item.id || "【当前树节点id】");
      } else if (item.linkType == "page") {
        path =
          "/dashboard/" +
          (this.appId || "【当前应用id】") +
          "/" +
          item.style +
          "/" +
          (item.id || "【当前树节点id】") +
          "/" +
          item.linkType +
          "/" +
          item.targetId;
      } else {
        path =
          "/dashboard/" +
          (this.appId || "【当前应用id】") +
          "/" +
          item.style +
          "/" +
          (item.id || "【当前树节点id】") +
          "/" +
          item.linkType +
          "/index";
      }
      alert(path);
    },
    helpnotes(type) {
      let mdurl = '/helpDoc/platform/navigator.md';
      if (type == 'auth') mdurl = '/helpDoc/platform/authory.md';
      PF.showHelp({url:mdurl});
    },
    chageTarget() {
      if (!this.form.target) return;
      if (this.form.linkType == 'view') {
        this.viewTarget = this.form.target;
        this.viewTargetId = this.form.targetId;
      } else if (this.form.linkType == 'page') {
        this.pageTarget = this.form.target;
        this.pageTargetId = this.form.targetId;
      } else if (this.form.linkType == 'cate') {
        this.cateTarget = this.form.target;
        this.cateTargetId = this.form.targetId;
      } else if (this.form.linkType == 'inner') {
        this.innerTarget = this.form.target;
        this.innerTargetId = this.form.targetId;
      }
    },
    clearTarget() {
      this.viewTarget = '';
      this.viewTargetId = '';
      this.pageTarget = '';
      this.pageTargetId = '';
      this.cateTarget = '';
      this.cateTargetId = '';
      this.innerTarget = '';
      this.innerTargetId = '';
    },
    setFormExp() {
      if (this.form && this.form.authorityForm && this.form.authorityForm.length > 0) {
        this.authorityForm = this.form.authorityForm;
      }
      this.dialogFormVisible = true;
    },
    clearFormExp() {
      this.form.exp = '';
      this.form.authorityForm = [];
      this.authorityForm = [{
        zdmc:'',
        zdmcstr:'',
        bjf: '',
        srz: '',
        srzstr: '',
        gxf: 'and'
      }];
    },
    setAuthory() {
      this.form.exp = this.previewAuthory;
      this.form.authorityForm = this.authorityForm;
      this.closeAuthory();
    },
    addAuthory() {
      this.authorityForm.push({
        zdmc:'',
        zdmcstr: '',
        bjf: '',
        srz: '',
        srzstr: '',
        gxf: 'and'
      });
    },
    closeAuthory() {
      this.authorityForm = [{
        zdmc:'',
        zdmcstr: '',
        bjf: '',
        srz: '',
        srzstr: '',
        gxf: 'and'
      }];
      this.dialogFormVisible = false;
    },
    selectZdmc(authoryItem, scopeIndex) {
      authoryItem.bjf = '';
      authoryItem.srz = '';
      authoryItem.srzstr = '';
      this.scopeIndex = scopeIndex;
      this.dialogSelectVisible = true;
    },
    setCurzdmc() {
      // if (this.curAuthoyItem)
      if (this.scopeIndex !== null && this.curzdmc) {
        this.authorityForm[this.scopeIndex].zdmc = this.curzdmc;
        this.authorityForm[this.scopeIndex].zdmcstr = this.zdmcKv[this.curzdmc] || '';
      }
      this.clearCurzdmc();
      this.dialogSelectVisible = false;
    },
    clearCurzdmc(){
      this.curzdmc = '';
      this.scopeIndex = null;
    },
    selectDept(authoryItem, scopeIndex){
      let selectNode = this.authorityForm[scopeIndex].srz ? this.authorityForm[scopeIndex].srz : '';
      let defaultParams = {};
      if (!this.userInfo || !this.userInfo.developer) defaultParams.listAble = true;
      PF.show('tree',{
        url: this.mwUrl("/api/org/listDepartmentTree"),
        defaultParams: defaultParams,
        selectNode:selectNode,
        types:{
          "1": {
            "icon": "fa fa-folder"
          },
          "2": {
            "icon": "fa fa-leaf"
          },
          "3": {
            "icon": "fa fa-users"
          },
          'default':{
            "icon": "fa fa-leaf"
          }
        },
        search: false,
        multiple:false,
        singleLeaf:false,
        clearBtn:true
      },(res) => {
        if (scopeIndex !== null) {
          this.authorityForm[scopeIndex].srz = !res?'':res.id;
          this.authorityForm[scopeIndex].srzstr = !res?'':res.name;
        }
      });
    }
  }
};
</script>
<style scoped>
.el-input,
.el-textarea {
  width: 60%;
}
.navigator-help pre p {
  line-height: 1;
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/index/views/appModule/navigator_tree/navigator_form.vue